module.exports = __webpack_public_path__ + "static/media/discussion.87cf0344.png";